import React from 'react'

interface IParagraphProps {
  children: string
  maxLength?: number
  className?: string
}

export const Paragraph = ({ children, maxLength, className }: IParagraphProps) => {
  const text = maxLength && children.length > maxLength ? children.substring(0, maxLength - 3) + '...' : children
  return (
    <span style={{ whiteSpace: 'pre-line' }} className={className}>
      {text}
    </span>
  )
}
